import axios from "axios";
import qs from "qs";
import { Message } from "element-ui";
import that from "../main";
import DonMessage from "../utils/message";
import store from '../store/store.js';
/**
 * @description: 实时 60 服务器
 */
const $http = axios.create({
    baseURL: process.env.VUE_APP_HTTP_INDEX_URL,
    timeout: 300000,
    responseType: "json",
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Accept-Language': store.state.language.language||'zh-CN'
    }
});

// 请求qs序列化
$http.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem("token");
        if (
            config.method === "post" &&
            config.headers["Content-Type"] ===
                "application/x-www-form-urlencoded"
        ) {
            config.data = qs.stringify(config.data, {
                arrayFormat: "indices",
                allowDots: true
            });
        }
        if (token) {
            config.headers.token = token;
        }
        return config;
    },
    error => {
        DonMessage({
            showClose: true,
            message: error && error.data.error_msg,
            type: "error"
        });
        return Promise.reject(error.data.error_msg);
    }
);

// 接收数据，刷新token，封装res.bus_json
$http.interceptors.response.use(
    res => {
        if (res.data) {
            if (res.data.token && res.data.token.length) {
                sessionStorage.setItem("token", res.data.token);
            }
            switch (res.data.error_code) {
                case "-1":
                    DonMessage.warning({
                        showClose: true,
                        message: "请求超时，请重新登录"
                    });
                    sessionStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: "/login"
                        });
                    }, 1000);
                    break;
                case "0":
                    return res.data;
                case "1":
                    if (
                        res.data.error_msg === "token is null" &&
                        res.data.error_msg != "账号密码错误！"
                    ) {
                        DonMessage.error({
                            showClose: true,
                            message: res.data.error_msg + "，请重新登录"
                        });
                        sessionStorage.clear();
                        setTimeout(() => {
                            that.$router.push({
                                path: "/login"
                            });
                        }, 1000);
                    }
                    if (res.data.error_msg !== "token is null") {
                        DonMessage.error({
                            showClose: true,
                            message: res.data.error_msg
                        });
                    }
                    if (!res.data.bus_json) {
                        return res.data;
                    }
                    break;
                case "2":
                    DonMessage.warning({
                        showClose: true,
                        message: res.data.error_msg
                    });
                    sessionStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: "/login"
                        });
                    }, 1000);
                    break;
                default:
                    //其他默认返回的blob文件流
                    return res.data;
            }
        }
    },
    error => {
        console.log(error);
    }
);

export default $http;
